import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';

function Navigation() {
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo">Vulpix Technology</Link>
        <div className="nav-links">
          <Link to="/#services" onClick={(e) => {
            if (location.pathname !== '/') {
              e.preventDefault();
              window.location.href = '/#services';
            }
          }}>Services</Link>
          <Link to="/case-studies">Case Studies</Link>
          <Link to="/#schedule" onClick={(e) => {
            if (location.pathname !== '/') {
              e.preventDefault();
              window.location.href = '/#schedule';
            }
          }}>Schedule Meeting</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;

